/**
 * TODO
 *  BEST SIZE: 41.7kb with OribitControls, 30.1kb without
 *  RELEASE INSTRUCTIONS:
 *   - comment out gui import
 *   - comment out token data generation
 * 
 *   - Get rid of dat gui saving... just pass around URLs/Tokens?
 *   - Adjusting reflectivity doesn't update the token (doesnt call update uniforms)
 *   - Write script to change likes.txt to new token values (colors, probabilites)
 *   - Add background params to token just in case
 *   - Add layout params just in case (e.g. 1, 5, 9, kusama, hyperspace)
 *     - For multiple eyes, rotate the hash in a deterministic way
 *   - Add 'special' params to token e.g. for hyperspace?
 *   - Fix token mappings, including probability distributions :/
 *     - Add shaping functions and constraints
 *   - DAT saves only the token now
 * 
 *  TWEAKING
 *  - bug with dragon eye and outer ring - repeats top and bottom
 *  - Take out orbit controls, make eye follow mouse cursor, and have keyboard commands for other movements
 *  - Is min pupil dllation too small? 
 *   - Make max animation speed slower? (depends on texture)
 *     - Consider making speeds discrete (STILL, ULTRA SLOW, SLOW, MEDIUM, FAST, HYPER)
 *       - Maybe just do this for emitting animation feature (sum base+fiber anim speed and emit name?)
 *   - If radial fibers, frequency should be lower (to match visual look of non-radial)
 *     - Fibers should be eiter radial, or double mirror? Should we remove non-radial fibers? or make it super rare
 *   - See SUXFILE below
 *   - Review color palettes
 *   - Review random sets for each base texture, fiber, color palette etc
 *   - Generate a 'rarity guide' with current proabilities to check results
 *   - View lots of galleries with no animation (opensea simulation)
 * 
 *  GLSL Tweaks
 *   - Maybe blot should have some spot noise like original? (optional)
 *   - Make Acid use base colors?
 * 
 *  EXTRA FEATURES
 *   - static image returned by API is an animated GIF so they show animated on opensea?
 *   - Add property with the ENS of the minter (creator?), and time of mint? Kind of like astrology? Give it names like seasons or phases etc.
 *   - Rare feature - illuminati triangle background?
 *   - Super rare eye of god changes through all eyes infinitely (do it as token #666 ?)
 *   - Make eye follow cursor if on opensea (maybe if not full screen? can we check if framed?)
 *   - Add keyboard commands to zoom, pan, pause etc
 *      - keypress to initiate cycling zooming?
 *      - Zooming move forward for single eye based on keypres 
 *      - keys to adjust anim speed or stop
 *      - keys to adjust lighting?
 *      - keypress for screenshot or video?
 *      - some kind of easter egg keypress (maybe morph into another eye type? or rapidly cycle random types?)
 *   - Backgrounds
 *     - Box like skateboarding? Palettes from base colors, or turrell?
 *   - Oculus support- look at https://github.com/mrdoob/three.js/tree/master/examples/jsm/webxr
 * 
 *  CLEANUP
 *   - Re-Write or shrink OrbitControls
 *   - Remove temporary gallery stuff for color testing, including mouse events
 *   - REFACTOR shader code 
 *     - Remove unneeded presets and algos
 *     - clean up params and globals
 *   - Examine shader code licenses and decide how to handle
 *   - Performance improvements from threejs course
 * 
 * 
 *  GRAIL zooming piece
 *   - More lights
 *   - Lights moving around?
 *   - Random eyes not presets
 *   - More depth, more eyes
 *   - Periodically line them up in gallery view then resume
 *  
 *  FUTURE IDEAS:
 *  - beads or lights flying around the eye 
 *  - try changes in elevation in eye with fibers etc (see if it makes shadows in crevices)?
 *  - eye of sauron https://www.shadertoy.com/view/ldBGWW
 *  - combustion (in eye, or background): https://www.shadertoy.com/view/4tlSzl
 *  - Some completely different styles (charcoal, watercolor... xcopy style?) fidenze, ringers, famous art genres
 *  - Mess with vertex shader or a map to give texture/depth to the eye surface, like a roughness to the reflection
 *  - Make an instagram AR filter (https://sparkar.facebook.com/ar-studio/learn/scripting/shader-code-asset/#defining-functions)
 */
// For mp4 recording:
// - module import
// - hardcoding of sizes
// - lines from animation loop
// - stuff just bfore init
// - may need to change animation loop to call tick directly at end of file, and uncomment requestAnimationFrame line
// (note capture recording with 'v', for still image use chrome screenshot)

import './style.css'
// import * as THREE from 'three'
// import { buildGUI, buildColorGUI, updateUniforms } from './gui' // Comment this line to remove gui in release
import { ARButton } from './ARButton.js'
import { OrbitControls } from './OrbitControls.js'
import { eyeAnimation } from './animation'
import { colorPalettes, baseTextureTypes, fiberTypes, symmetryTypes, reflectivityTypes, ringTypes, HashParams, generateProperties, propertiesToToken } from './features'
import eyeVertexDeclShader from './shaders/eye/vertex_decl.glsl'
import eyeVertexMainShader from './shaders/eye/vertex_main.glsl'
import eyeFragmentDeclShader from './shaders/eye/fragment_decl.glsl'
import eyeFragmentMainShader from './shaders/eye/fragment_main.glsl'
// import * as CanvasCapture from 'canvas-capture'


/**
 * Generate random token data for testing
 * REMOVE FOR RELEASE
 */
function genRandomToken(projectNum) {
    let data = {}
    let hash = "0x"
    for (var i = 0; i < 64; i++) {
        hash += Math.floor(Math.random() * 16).toString(16)
    }
    data.hash = hash;
    data.tokenId = (projectNum * 1000000 + Math.floor(Math.random() * 1000)).toString()
    return data;
}
let tokenData = genRandomToken(1111);




// Generate random number in specified range
const randRange = (min, max) => {
    return Math.random() * (max - min) + min;
}


/**
 * Base setup (globals)
 */
const canvas = document.querySelector('canvas')
const scene = new THREE.Scene()
const sphereGeometry = new THREE.SphereGeometry(1, 32, 32, 0, Math.PI, 0, Math.PI)
const eyes = []
const clock = new THREE.Clock()
const preset = (new URL(window.location.href)).searchParams.get('preset')
const urlHash = (new URL(window.location.href)).searchParams.get('hash')
if (urlHash) {
    tokenData.hash = urlHash
}

// Lights - This is now fixed or all presets
let lightColors = {
    ambient: '#FFFFFF',
    point: '#FFFFFF'
}
const ambientLight = new THREE.AmbientLight(lightColors.ambient, 0.2)
scene.add(ambientLight)
const pointLight = new THREE.PointLight(lightColors.point, 1.0)
pointLight.position.x = 2
pointLight.position.y = 3
pointLight.position.z = 4
scene.add(pointLight)

// Window size
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
        // sizes.width = 3840
        // sizes.height = 2160

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
    // camera.position.set(0, 0, 1.75)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.target = new THREE.Vector3(0, 0, -1.75)

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// TODO Background
let background = {
    color1: '#000000',
    color2: '#FFFFFF',
    shape: 'linear'
}
scene.background = new THREE.Color(background.color1)

// Web XR
const ar = ARButton.createButton(renderer, scene, background.color1)
if (ar) {
    document.body.appendChild(ar)
    renderer.xr.enabled = true
}

if (preset == 'hyperspace') {
    // Fog
    const fog = new THREE.Fog('#000000', 15, 20)
    scene.fog = fog
}

// Mouse click stuff for gallery (TODO: remove when minifying?)
const raycaster = new THREE.Raycaster()
const mouse = new THREE.Vector2()
let mouseIntersect = null
if (preset == 'gallery') {
    // Setup mouse clicks
    window.addEventListener('mousemove', (event) => {
        mouse.x = event.clientX / sizes.width * 2 - 1
        mouse.y = -(event.clientY / sizes.height) * 2 + 1
    })
    window.addEventListener('click', () => {
        if (mouseIntersect) {
            const hash = mouseIntersect.object.userData.properties.hash
            const url = new URL(window.location.href)
            window.open('?hash=' + hash, '_blank').focus()
        }
    })
}


/**
 * Generate a bunch of eyes for color testing, and hyperspace
 */
const generateEyes = (num) => {
    for (let i = 0; i < num; i++) {
        let props = generateProperties(new HashParams(genRandomToken(1111).hash))

        // Fix certain properties (color is automatically fixed by GUI)
        // props.baseTextureType = "Mech"
        // props.baseRadial = true
        // props.fiberType = "none"

        const sphereMesh = createEyeMesh(props)
        sphereMesh.position.x = ((i % 3) - 1.5) * 2
        sphereMesh.position.y = (Math.floor(i / 3) - 1) * -2
        sphereMesh.position.z = 0
        if (eyes[i]) {
            scene.remove(eyes[i])
            eyes[i] = sphereMesh
        } else {
            eyes.push(sphereMesh)
        }
        scene.add(sphereMesh)
    }
}

/**
 * Infite eye field
 */
const hyperspace = (eyes, elapsedTime) => {
    const rate = 0.02
    for (let i = 0; i < eyes.length; i++) {
        const pos = eyes[i].position.z
        if (eyes[i].position.z > 0) {
            let props = generateProperties(new HashParams(genRandomToken(1111).hash))
            const newMesh = createEyeMesh(props)
            scene.remove(eyes[i])
            eyes[i] = newMesh
            eyes[i].position.x = randRange(-8, 8)
            eyes[i].position.y = randRange(-5, 5)
            eyes[i].position.z = -20
            const scale = randRange(0.2, 2)
            eyes[i].scale.set(scale, scale, scale)
            scene.add(newMesh)
        } else {
            // TODO - different rate per eye
            eyes[i].position.z += rate
        }
    }
}



/**
 * Initialize models
 */
const init = () => {
    const p = new HashParams(tokenData.hash)
    if (preset == 'hyperspace') {
        generateEyes(50)
        for (let i = 0; i < eyes.length; i++) {
            eyes[i].position.x = randRange(-8, 8)
            eyes[i].position.y = randRange(-5, 5)
            eyes[i].position.z = randRange(-20, 0)
            const scale = randRange(0.2, 2)
            eyes[i].scale.set(scale, scale, scale)
        }
        // camera.position.set(0, 0, 11)
    } else if (preset == 'gallery') {
        // Create an ordered grid of 9 random eyes
        generateEyes(9)
        createColorGUI(eyes)
        camera.position.z = 5
    } else {
        // Create a single eye with specified preset or hash value
        const sphereMesh = createEyeMesh(generateProperties(p))
        sphereMesh.position.z = -1.75
        eyes.push(sphereMesh)
        scene.add(sphereMesh)
        createGUI(sphereMesh, preset)
    }
}


/**
 * Create an eye
 */
const createEyeMesh = (properties) => {
    // Standard material for lighting effects, will inject custom shaders
    const material = new THREE.MeshStandardMaterial({
        metalness: 0.0,
        roughness: 0.45,
        side: THREE.DoubleSide, // Doesn't work well with THREE.js r124
        transparent: true,
        opacity: 1, // HACK - I'm using this to represent blink amount
        aoMap: new THREE.DataTexture(Uint8Array.from([255, 255, 255]), 1, 1, THREE.RGBFormat), // Hack
        aoMapIntensity: 0, // HACK - I'm using this to represent pupil dilation amount
        depthWrite: false, // Using this to avoid display bugs with intersecting spheres
        defines: {
            IRIS_RADIUS: 0.5,
            PUPIL_RADIUS: 0.075
        }
    })

    // Mesh
    const sphereMesh = new THREE.Mesh(sphereGeometry, material)

    sphereMesh.userData.properties = properties

    // Load color values (delete this eventually)
    if (properties.colorPalette != 'custom') {
        const palette = colorPalettes.find(e => e.name == properties.colorPalette)
        properties.baseColor1 = palette.baseColor1
        properties.baseColor2 = palette.baseColor2
        properties.baseColor3 = palette.baseColor3
        properties.baseColor4 = palette.baseColor4
        properties.innerColor = palette.innerColor
        properties.fiberColor = palette.fiberColor
    }

    // Custom uniforms (injected into material)
    sphereMesh.userData.customUniforms = {
        uTime: { value: 0 },

        uBaseColor1: { value: new THREE.Color(properties.baseColor1) },
        uBaseColor2: { value: new THREE.Color(properties.baseColor2) },
        uBaseColor3: { value: new THREE.Color(properties.baseColor3) },
        uBaseColor4: { value: new THREE.Color(properties.baseColor4) },
        uInnerColor: { value: new THREE.Color(properties.innerColor) },
        uFiberColor: { value: new THREE.Color(properties.fiberColor) },

        uBaseTextureType: { type: "i", value: baseTextureTypes.find(e => e.name == properties.baseTextureType).value },
        uBaseTextureFrequency: { value: properties.baseTextureFrequency },
        uBaseParamA: { value: properties.baseParamA },
        uBaseParamB: { value: properties.baseParamB },
        uBaseParamC: { value: properties.baseParamC },
        uBaseAnimation: { value: properties.baseAnimation },
        uBaseRadial: { value: properties.baseRadial ? 1 : 0 },
        uBaseSymmetry: { value: symmetryTypes.find(e => e.name == properties.baseSymmetry).value },

        uInnerRingType: { value: ringTypes.find(e => e.name == properties.innerRingType).value },
        uInnerRingSize: { value: properties.innerRingSize },
        uInnerRingSpread: { value: properties.innerRingSpread },
        uDragonPupil: { value: properties.dragonPupil ? 1 : 0 },

        uFiberType: { type: "i", value: fiberTypes.find(e => e.name == properties.fiberType).value },
        uFiberFrequency: { value: properties.fiberFrequency },
        uFiberIntensity: { value: properties.fiberIntensity },
        uFiberParamA: { value: properties.fiberParamA },
        uFiberAnimation: { value: properties.fiberAnimation },
        uFiberRadial: { value: properties.fiberRadial ? 1 : 0 },
        uFiberSymmetry: { value: symmetryTypes.find(e => e.name == properties.fiberSymmetry).value },
    }

    // Inject custom uniforms and shaders
    material.onBeforeCompile = (shader) => {
        Object.assign(shader.uniforms, sphereMesh.userData.customUniforms)
        shader.vertexShader = shader.vertexShader.replace('#include <common>', '#include <common>\n' + eyeVertexDeclShader)
        shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>', '#include <begin_vertex>\n' + eyeVertexMainShader)
        shader.fragmentShader = shader.fragmentShader.replace('#include <common>', '#include <common>\n' + eyeFragmentDeclShader)
        shader.fragmentShader = shader.fragmentShader.replace('#include <color_fragment>', '#include <color_fragment>\n' + eyeFragmentMainShader)
    }

    // Animation mixer
    sphereMesh.userData.mixer = new THREE.AnimationMixer(sphereMesh);
    sphereMesh.userData.nextEyeMovement = randRange(properties.eyeMovementMinPeriod, properties.eyeMovementMaxPeriod)
    sphereMesh.userData.nextBlink = randRange(properties.blinkMinPeriod, properties.blinkMaxPeriod)
    sphereMesh.userData.nextDilation = randRange(properties.dilationMinPeriod, properties.dilationMaxPeriod)
    sphereMesh.userData.blinkAction = null
    sphereMesh.userData.eyeMoveAction = null
    sphereMesh.userData.eyeDilateAction = null

    return sphereMesh
}


/**
 * Generate GUIs if gui.js is imported (not in released script)
 */
const createGUI = (mesh, preset) => {
    if (typeof buildGUI === 'undefined') {
        // Do nothing
    } else {
        // Build the gui
        buildGUI(mesh, preset, colorPalettes, baseTextureTypes, ringTypes, fiberTypes, symmetryTypes, reflectivityTypes)
    }
}
const createColorGUI = () => {
    if (typeof buildColorGUI === 'undefined') {
        // Do nothing
    } else {
        // build the gui
        buildColorGUI(eyes, colorPalettes, generateEyes)
    }
}


/**
 * A bit of fun
 */
const dmt = (eye) => {
    const props = generateProperties(new HashParams(genRandomToken(1111).hash))
    eye.userData.properties = props
    updateUniforms(eye)
}


/**
 * Tick function
 */
const tick = () => {
    const deltaTime = clock.getDelta()
    const elapsedTime = clock.elapsedTime

    // Update controls
    controls.update()

    // Update eye animations
    eyes.forEach((mesh) => {
        // dmt(mesh)

        mesh.userData.customUniforms.uTime.value = elapsedTime
        eyeAnimation(mesh, clock)
        mesh.userData.mixer.update(deltaTime)
    })

    // Move eyes forward if hyperspace
    if (preset == 'hyperspace') {
        hyperspace(eyes, elapsedTime)
    }

    // Handle mouse hover and click in gallery
    if (preset == 'gallery') {
        raycaster.setFromCamera(mouse, camera)

        const objectsToTest = eyes
        const intersects = raycaster.intersectObjects(objectsToTest)

        for (const object of objectsToTest) {
            if (!(intersects[0] === object)) {
                object.scale.set(1, 1, 1)
            }
        }

        if (intersects.length) {
            intersects[0].object.scale.set(1.5, 1.5, 1.5)
            mouseIntersect = intersects[0]
        } else {
            mouseIntersect = null
        }

    }

    // Render
    renderer.render(scene, camera)

    // TEMPORARY - for recording
    // if (CanvasCapture.isRecording()) {
    //     CanvasCapture.recordFrame()
    //     framesRecorded++
    //     if (framesRecorded % 60 == 0) {
    //         console.log(Math.floor(framesRecorded / 60) + ' seconds')
    //     }
    // }

    // Using setAnimationLoop instead
    // window.requestAnimationFrame(tick)
}


/**
 * TEMPORARY - for recording video file
 */
// let framesRecorded = 0
// CanvasCapture.init(canvas)
// CanvasCapture.bindKeyToVideoRecord('v')
// CanvasCapture.bindKeyToGIFRecord('g')
// CanvasCapture.bindKeyToPNGSnapshot('p')
// CanvasCapture.bindKeyToJPEGSnapshot('j')
// CanvasCapture.setVerbose(false)
// ffmpeg -i ./WEBM_Capture.webm -c:v libx265 -crf 5 -preset fast -tag:v hvc1 ./eye.mp4
// Check bitrate, adjust crf up to lower it, keep it below 60k

// ************

init()

// Turn off animation for image generation (move this somewhere)
// alternative: chrome --headless --screenshot --window-size=1920,1080 http://192.168.164.236:8080/
const anim = (new URL(window.location.href)).searchParams.get('anim')
if (anim && anim == 'false') {
    // Draw one tick
    tick()
} else {
    renderer.setAnimationLoop(tick)
}


// renderer.setAnimationLoop(tick)
// tick()